import * as React from "react";
import './Pick.css';
import '../components/Typograph.css';
import AppHeader from '../components/AppHeader';
import AppFooter from "../components/AppFooter";
import ImageRadioPicker from "../components/ImageRadioPicker";
import {HengType} from "../Model";
import Select from 'react-select'
import T2Image from '../images/T2.jpg'
import L2Image from '../images/L2.jpg'
import H2Image from '../images/H2.jpg'
import T3Image from '../images/T3.jpg'
import L3Image from '../images/L3.jpg'
import HT3Image from '../images/HT3.jpg'
import LT3Image from '../images/LT3.jpg'

const TypesWithSubTypes = [
    HengType.L2,
    HengType.L3,
    HengType.LT3
];

const DropdownOptions = [
    { value: '200', label: '200mm' },
    { value: '300', label: '300mm' },
    { value: '400', label: '400mm' },
    { value: '500', label: '500mm' },
    { value: '600', label: '600mm' },
]

const DropdownStyle = {
    menu : (provided) => ({
        ...provided,
        top: "-570%"
    })
}

export default class SuspensionPick extends React.Component {
    canContinue = () => {
        if (!this.props.currentValue) return false;
        if (TypesWithSubTypes.includes(this.props.currentValue.type)) {
            return this.props.currentValue.variant;
        } else {
            return true;
        }
    }

    setVariant = (selected) => {
        this.props.currentValue.variant = selected.value;
        this.props.currentValue.fullVariant = selected;
        this.props.handlePageChange(this.props.currentValue);
    }

    render() {
        return (
            <div className="page">
                <AppHeader title="Hengtype"/>

                <div className="page-middle">
                    <h1 className="pick-title">Welk heng type is van toepassing?</h1>

                    <div className="pick-body scrollable">
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={{type: HengType.T2, fullVariant: null}}
                                          child="type"
                                          image={T2Image}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={{type: HengType.L2, fullVariant: null}}
                                          child="type"
                                          image={L2Image}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={{type: HengType.H2, fullVariant: null}}
                                          child="type"
                                          image={H2Image}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={{type: HengType.T3, fullVariant: null}}
                                          child="type"
                                          image={T3Image}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={{type: HengType.L3, fullVariant: null}}
                                          child="type"
                                          image={L3Image}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={{type: HengType.HT3, fullVariant: null}}
                                          child="type"
                                          image={HT3Image}/>
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={{type: HengType.LT3, fullVariant: null}}
                                          child="type"
                                          image={LT3Image}/>
                    </div>
                    <p className="detail-warning-text small" hidden={!this.props.currentValue || !TypesWithSubTypes.includes(this.props.currentValue.type)}>
                        Dit type bevat staartgehengen.<br/>
                        Welke lengte moeten deze gehengen hebben?
                        <Select className="dropdown-picker"
                                options={DropdownOptions}
                                placeholder="Lengte selecteren..."
                                styles={DropdownStyle}
                                value={this.props.currentValue ? this.props.currentValue.fullVariant : null}
                                onChange={this.setVariant} />
                    </p>
                </div>
                <AppFooter onNext={this.props.handleNextPage}
                           onPrevious={this.props.handlePreviousPage}
                           enableNext={this.canContinue()}/>
            </div>
        );
    }
}
